export default defineNuxtRouteMiddleware(async (to, from) => {
  
    const baseTitle = "Livia"

    // Skip if it's a /property/[id] route
    if (to.path.includes('/property/')) {
        return;
    }

    // Special case for cities/[state]/[city] route
    // Extract state and city from the path
    const cityMatch = to.path.match(/^\/cities\/([^/]+)\/([^/]+)$/);
    if (cityMatch) {
        const state = cityMatch[1];
        const city = cityMatch[2];
        const suffix = `${city}, ${state}`
        useHead({
            title: `${baseTitle} ${suffix ? `| ${suffix}` : ""}`
        })
        return;
    }


    const headInfoCollection = [
      { name: 'home', title: "Home" },
      { name: 'login', title: "Login" },
      { name: 'profile-builder', title: "Profile Builder" },
      { name: 'property-search', title: "Properties" },
      { name: 'city-selection', title: "Cities" },
      { name: 'cities', title: "Cities" },
      { name: 'bookings', title: "Bookings" },
      { name: 'planning', title: "Planning" },
    ]

    const suffix = headInfoCollection.find(c => c.name === to.name)?.title

    useHead({
        title: `${baseTitle} ${suffix ? `| ${suffix}` : ""}`
    })
  

    return;
});
